import { user } from "@lhd/features/users/selector";
import { Company } from "@lhd/types";
import { getCompanyId } from "@lhd/utility";
import { useMemo } from "react";
import { useSelector } from "react-redux";

export const useAttendanceManagementPermission = () => {
  const auth = useSelector(user);
  const companyId = getCompanyId();

  const isSuperAdmin = !!auth?.is_admin && !!auth?.is_on_company_admin;
  const isCompanyAdmin = !!auth?.is_admin && !auth?.is_on_company_admin;
  const canManageWorkersAttendance = !!auth?.is_admin;

  const currentWorkerId = useMemo(() => {
    const wid = auth?.workers?.find(
      (w) => w?.company_id?.toString() === companyId?.toString(),
    )?.id;
    if (wid == null) return undefined;
    const n = Number(wid);
    return Number.isFinite(n) && n > 0 ? n : undefined;
  }, [auth?.workers, companyId]);

  const companies: Company[] = useMemo(
    () => auth?.companies ?? [],
    [auth?.companies],
  );

  const hasCurrentWorker = currentWorkerId != null;
  const canPunchAttendance = hasCurrentWorker;
  const canOpenAttendanceManagement =
    canManageWorkersAttendance || hasCurrentWorker;

  return {
    canManageWorkersAttendance,
    isSuperAdmin,
    isCompanyAdmin,
    currentWorkerId,
    hasCurrentWorker,
    canPunchAttendance,
    canOpenAttendanceManagement,
    companies,
    isAdmin: !!auth?.is_admin,
  };
};
